
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label ,FormGroup, Button, CardTitle, Spinner, Table} from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import axios from '../../axios';
import Select from 'react-select'
import moment from 'moment';
import numeral from 'numeral'
import _ from 'lodash'
import SweetAlert from "react-bootstrap-sweetalert";
import { Backdrop, makeStyles } from "@material-ui/core";
import "./bookingandshipmentstyle.css"

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display:'flex',
    flexDirection:'column',
  },
}));

const BookingAndShipment=()=>{
        
    //companyhelp
    const [companyhelp,setcompanyhelp]=useState([])
    const [Companyvalue, setCompanyvalue] = useState({})

    const [showTable, setShowTable] = useState(false);

    //buyerhelp
    const [buyerhelp,setbuyerhelp]=useState([])
    const[buyervalue,setbuyervalue]=useState({label:"All", value:"0"})

    //periodhelp
    const[periodvalue,setperiodvalue]=useState({ label: "Select", value: "" })
    const[periodtypevalue,setperiodtypevalue]=useState({ label: "Select", value: "" })
    const [periodtypeoption,setperiodtypeoption]=useState([])

    //datanotfoundpopup
    const [notfoundpopup, setnotfoundpopup] = useState(false)
    const [perioderr, setperioderr] = useState(false)
    const [periodtypeerr, setperiodtypeerr] = useState(false)

    const classes = useStyles();
    const [Spinner1, setSpinner1] = useState(false)
    const [fromdate, setfromdate] = useState(new Date())
    const [todate, settodate] = useState(new Date())
    //tabledata
    const[tabledata,settabledata]=useState([])
    const[monthss,setmonthss]=useState([])
    const[ordermonthycol,setordermonthycol]=useState([])
    const[shipmonthycol,setshipmonthycol]=useState([])
    const[datatype,setdatatype]=useState('monthly')
    const[fromdatedis,setfromdatedis]=useState(true)
    const[todatedis,settodatedis]=useState(true)
    const[periodtypedis,setperiodtypedis]=useState(false)
    const[yearvalue,setyearvalue]=useState({label:"2023", value:2023})
    const monthCollection = [];
    

    useEffect(()=>{
        company()
        buyer()
        setCompanyvalue(JSON.parse(localStorage.getItem('company')))

        var date =  new Date()
        var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
        var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
        setfromdate(moment(firstday).format('YYYY-MM-DD'))
        settodate(moment(lastday).format('YYYY-MM-DD'))
    },[])

    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const orderName = [{"Jan":'JanOD'},{"Jan":'JanODR'},{"Feb":'FebOD'},{"Feb":'FebODR'},{"Mar":'MarOD'},{"Mar":'MarODR'},{"Apr":'AprOD'},{"Apr":'AprODR'}, {"May":'MayOD'}, {"May":'MayODR'}, {"Jun":'JunOD'},{"Jun":'JunODR'},{"Jul":'JulOD'},{"Jul":'JulODR'}, {"Aug":'AugOD'},{"Aug":'AugODR'}, {"Sep":'SepOD'}, {"Sep":'SepODR'}, {"Oct":'OctOD'}, {"Oct":'OctODR'}, {"Nov":'NovOD'}, {"Nov":'NovODR'}, {"Dec":'DecOD'},{"Dec":'DecODR'}]

    const shipName = [{"Jan":'JanSD'},{"Jan":'JanSDR'},{"Feb":'FebSD'},{"Feb":'FebSDR'},{"Mar":'MarSD'},{"Mar":'MarSDR'},{"Apr":'AprSD'},{"Apr":'AprSDR'}, {"May":'MaySD'}, {"May":'MaySDR'}, {"Jun":'JunSD'},{"Jun":'JunSDR'},{"Jul":'JulSD'},{"Jul":'JulSDR'}, {"Aug":'AugSD'},{"Aug":'AugSDR'}, {"Sep":'SepSD'}, {"Sep":'SepSDR'}, {"Oct":'OctSD'}, {"Oct":'OctSDR'}, {"Nov":'NovSD'}, {"Nov":'NovSDR'}, {"Dec":'DecSD'},{"Dec":'DecSDR'}]
    

    const periodhelp=[
        {label:"Quarterly",value:3},
        {label:"Half-Yearly",value:6},
        {label:"Annual",value:12},
        {label:"Custom",value:69},
    ]

    const yearhelp=[
      {label:"2027",value:2027},
      {label:"2026",value:2026},
      {label:"2025",value:2025},
      {label:"2024",value:2024},
      {label:"2023",value:2023},
      {label:"2022",value:2022},
      {label:"2021",value:2021},
      {label:"2020",value:2020},
  ]

    const periodchange = (value) => {
      console.log(value)
      if(value === 3){
        const periodtypehelp1=[
          {label:"Jan - Mar",value:1},
          {label:"Apr - Jun",value:2},
          {label:"Jul - Sep",value:3},
          {label:"Oct - Dec",value:4}
        ]
        setperiodtypeoption(periodtypehelp1)
        setperiodtypevalue({ label: "Select", value: "" })
        setfromdatedis(true)
        settodatedis(true)
        setperiodtypedis(false)
      } else if(value === 6){
        const periodtypehelp2=[
          {label:"Jan - Jun",value:5},
          {label:"Jul - Dec",value:6}
        ]
        setperiodtypeoption(periodtypehelp2)
        setperiodtypevalue({ label: "Select", value: "" })
        setfromdatedis(true)
        settodatedis(true)
        setperiodtypedis(false)
      } else if(value === 12){
        const periodtypehelp3=[
          {label:"Jan - Dec",value:7}
        ]
        setperiodtypeoption(periodtypehelp3)
        setperiodtypevalue({ label: "Select", value: "" })
        setfromdatedis(true)
        settodatedis(true)
        setperiodtypedis(false)
      } else if(value === 69){
        setfromdatedis(false)
        settodatedis(false)
        setperiodtypedis(true)
        setperiodtypevalue({ label: "Select", value: "" })
      }
    }

    const periodtypechange = (value) => {
      // const day  = new Date().getFullYear()
      const day = yearvalue.value
      if(value === 1){ // -----------------------------------1
        setfromdate(`${day.toString()}-01-01`)
        settodate(`${day.toString()}-03-31`)
        // const months = ['Jan', 'Feb', 'Mar']
        // FOR SELECTING MONTH
          const fromDate = new Date(`${day.toString()}-01-01`);
          fromDate.getMonth(); 
          const toDate = new Date(`${day.toString()}-03-31`);
          toDate.getMonth(); 
          while (fromDate <= toDate) {
            const monthName = monthNames[fromDate.getMonth()];
            monthCollection.push(monthName);
            fromDate.setMonth(fromDate.getMonth() + 1);
          }
          setmonthss(monthCollection)
        
        const monthname = ['JanOD','JanODR','FebOD','FebODR','MarOD','MarODR']
        const monthname1 = ['JanSD','JanSDR','FebSD','FebSDR','MarSD','MarSDR']
        setordermonthycol(monthname)
        setshipmonthycol(monthname1)

      } else if(value === 2){ // -----------------------------------2
        setfromdate(`${day.toString()}-04-01`)
        settodate(`${day.toString()}-06-30`)
        // const months = ['Apr', 'May', 'Jun']

        const fromDate = new Date(`${day.toString()}-04-01`);
        fromDate.getMonth(); 
        const toDate = new Date(`${day.toString()}-06-30`);
        toDate.getMonth(); 

        while (fromDate <= toDate) {
          const monthName = monthNames[fromDate.getMonth()];
          monthCollection.push(monthName);
          fromDate.setMonth(fromDate.getMonth() + 1);
        }
        setmonthss(monthCollection)

        const monthname = ['AprOD','AprODR', 'MayOD', 'MayODR', 'JunOD','JunODR']
        const monthname1 = ['AprSD','AprSDR', 'MaySD', 'MaySDR', 'JunSD','JunSDR']
        setordermonthycol(monthname)
        setshipmonthycol(monthname1)
      } else if(value === 3){ // -----------------------------------3
        setfromdate(`${day.toString()}-07-01`)
        settodate(`${day.toString()}-09-30`)
        // const months = ['Jul', 'Aug', 'Sep']
        const fromDate = new Date(`${day.toString()}-07-01`);
        fromDate.getMonth(); 
        const toDate = new Date(`${day.toString()}-09-30`);
        toDate.getMonth(); 

        while (fromDate <= toDate) {
          const monthName = monthNames[fromDate.getMonth()];
          monthCollection.push(monthName);
          fromDate.setMonth(fromDate.getMonth() + 1);
        }
        setmonthss(monthCollection)
        const monthname = ['JulOD','JulODR', 'AugOD','AugODR', 'SepOD', 'SepODR']
        const monthname1 = ['JulSD','JulSDR', 'AugSD','AugSDR', 'SepSD', 'SepSDR']
        setordermonthycol(monthname)
        setshipmonthycol(monthname1)
      } else if(value === 4){ // -----------------------------------4
        setfromdate(`${day.toString()}-10-01`)
        settodate(`${day.toString()}-12-31`)
        // const months = ['Oct', 'Nov', 'Dec']
        const fromDate = new Date(`${day.toString()}-10-01`);
        fromDate.getMonth(); 
        const toDate = new Date(`${day.toString()}-12-31`);
        toDate.getMonth(); 

        while (fromDate <= toDate) {
          const monthName = monthNames[fromDate.getMonth()];
          monthCollection.push(monthName);
          fromDate.setMonth(fromDate.getMonth() + 1);
        }
        setmonthss(monthCollection)
        const monthname = ['OctOD', 'OctODR', 'NovOD', 'NovODR', 'DecOD','DecODR']
        const monthname1 = ['OctSD', 'OctSDR', 'NovSD', 'NovSDR', 'DecSD','DecSDR']
        setordermonthycol(monthname)
        setshipmonthycol(monthname1)
      } else if(value === 5){// -----------------------------------5
        setfromdate(`${day.toString()}-01-01`)
        settodate(`${day.toString()}-06-30`)
        // const months = ['Jan', 'Feb', 'Mar','Apr','May','Jun']
        const fromDate = new Date(`${day.toString()}-01-01`);
        fromDate.getMonth(); 
        const toDate = new Date(`${day.toString()}-06-30`);
        toDate.getMonth(); 

        while (fromDate <= toDate) {
          const monthName = monthNames[fromDate.getMonth()];
          monthCollection.push(monthName);
          fromDate.setMonth(fromDate.getMonth() + 1);
        }
        setmonthss(monthCollection)
        const monthname = ['JanOD','JanODR','FebOD','FebODR','MarOD','MarODR','AprOD','AprODR', 'MayOD', 'MayODR', 'JunOD','JunODR']
        const monthname1 = ['JanSD','JanSDR','FebSD','FebSDR','MarSD','MarSDR','AprSD','AprSDR', 'MaySD', 'MaySDR', 'JunSD','JunSDR']
        setordermonthycol(monthname)
        setshipmonthycol(monthname1)
      } else if(value === 6){ // -----------------------------------6
        setfromdate(`${day.toString()}-07-01`)
        settodate(`${day.toString()}-12-31`)
        // const months = ['Jul', 'Aug', 'Sep', 'Oct','Nov','Dec']
        const fromDate = new Date(`${day.toString()}-07-01`);
        fromDate.getMonth(); 
        const toDate = new Date(`${day.toString()}-12-31`);
        toDate.getMonth(); 

        while (fromDate <= toDate) {
          const monthName = monthNames[fromDate.getMonth()];
          monthCollection.push(monthName);
          fromDate.setMonth(fromDate.getMonth() + 1);
        }
        setmonthss(monthCollection)
        const monthname = ['JulOD','JulODR', 'AugOD','AugODR', 'SepOD', 'SepODR', 'OctOD', 'OctODR', 'NovOD', 'NovODR', 'DecOD','DecODR']
        const monthname1 = ['JulSD','JulSDR', 'AugSD','AugSDR', 'SepSD', 'SepSDR', 'OctSD', 'OctSDR', 'NovSD', 'NovSDR', 'DecSD','DecSDR']
        setordermonthycol(monthname)
        setshipmonthycol(monthname1)
      } else if(value === 7){ // -----------------------------------7
        setfromdate(`${day.toString()}-01-01`)
        settodate(`${day.toString()}-12-31`)
        // const months = ['Jan', 'Feb', 'Mar','Apr','May','Jun','Jul', 'Aug', 'Sep', 'Oct','Nov','Dec']
        const fromDate = new Date(`${day.toString()}-01-01`);
        fromDate.getMonth(); 
        const toDate = new Date(`${day.toString()}-12-31`);
        toDate.getMonth(); 

        while (fromDate <= toDate) {
          const monthName = monthNames[fromDate.getMonth()];
          monthCollection.push(monthName);
          fromDate.setMonth(fromDate.getMonth() + 1);
        }
        setmonthss(monthCollection)
        const monthname = ['JanOD','JanODR','FebOD','FebODR','MarOD','MarODR','AprOD','AprODR', 'MayOD', 'MayODR', 'JunOD','JunODR','JulOD','JulODR', 'AugOD','AugODR', 'SepOD', 'SepODR', 'OctOD', 'OctODR', 'NovOD', 'NovODR', 'DecOD','DecODR']
        const monthname1 = ['JanSD','JanSDR','FebSD','FebSDR','MarSD','MarSDR','AprSD','AprSDR', 'MaySD', 'MaySDR', 'JunSD','JunSDR','JulSD','JulSDR', 'AugSD','AugSDR', 'SepSD', 'SepSDR', 'OctSD', 'OctSDR', 'NovSD', 'NovSDR', 'DecSD','DecSDR']
        setordermonthycol(monthname)
        setshipmonthycol(monthname1)
      }
    }

    const company=async()=>{
        await axios.instance.get("CompanyHelp/GetCompany")
        .then((res)=>{

            const data=res.data
            const option=data.map(row=>({
                "label":row.company,
                "value":row.companyId
            }))
            console.log(option,"companyhelp");
            setcompanyhelp(option)  
        }) 
    }
  
    const buyer=async()=>{
        await axios.instance.get("/BuyerHelp/BookedBuyerHelp")
        .then((res)=>{
            const data =res.data
            const option=data.map(row=>({
                "label":row.buyer,
                "value":row.buyerId
            }))
            console.log(option,"buyerhelp")
            option.push({"label":"All",
            "value":"0"})
            setbuyerhelp(option)
        })
    }

    const viewdata=async()=>{
      if(periodvalue.value.length !== 0){
       if(periodtypevalue.value.length !== 0 || periodvalue.value === 69){
        if(periodvalue.value === 69){
          let arr = []
          let arr1 = []
          const fromDate = new Date(fromdate);
          fromDate.getMonth(); 
          const toDate = new Date(todate);
          toDate.getMonth(); 
  
          while (fromDate <= toDate) {
            const monthName = monthNames[fromDate.getMonth()];
            monthCollection.push(monthName);
            fromDate.setMonth(fromDate.getMonth() + 1);
          }
          setmonthss(monthCollection)

          // OrderName Filter
          monthCollection.forEach(element => {
            viewOrderkey(orderName, element);
          });
          function viewOrderkey(array, key) {
            for (const obj of array) {
              if (obj.hasOwnProperty(key)) {
                arr.push(obj[key])
              }
            }
          }

          // Ship Name Filter
          monthCollection.forEach(element => {
            viewShipkey(shipName, element);
          });
          function viewShipkey(array, key) {
            for (const obj of array) {
              if (obj.hasOwnProperty(key)) {
                arr1.push(obj[key])
              }
            }
          }
          setordermonthycol(arr)
          setshipmonthycol(arr1)
        }
        setShowTable(true);
        setSpinner1(true)
        if(datatype === 'monthly'){
          await axios.instance.get(`/Booking_Shipment?companyid=${Companyvalue.value}&buyerid=${buyervalue.value}&fromdate=${moment(fromdate).format('YYYYMMDD')}&todate=${moment(todate).format('YYYYMMDD')}`)
          .then((res)=>{
            console.log(res.data,'MONTHLY')
            res.data==""? (settabledata([]) || setnotfoundpopup(true)) : settabledata(res.data)
          })
        } else {
          await axios.instance.get(`/Booking_Shipment/bookingShipmentOverall?companyid=${Companyvalue.value}&buyerid=${buyervalue.value}&fromdate=${moment(fromdate).format('YYYYMMDD')}&todate=${moment(todate).format('YYYYMMDD')}`)
          .then((res)=>{
            console.log(res.data,'OVERALL')
            res.data==""? (settabledata([]) || setnotfoundpopup(true)) : settabledata(res.data)
          })
        }
        setTimeout(() => {
            setSpinner1(false)
          }, 2000);
       } else {
        setperiodtypeerr(true)
       }
      } else {
          setperioderr(true)
      }
  }
   
  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5 m-3 pt-sm-5">
      <div  style={{justifyContent:'center', alignItems:'center'}}>
          <div>  
            <Backdrop  open={Spinner1} className={classes.backdrop} >
              <Spinner>
                Loading...
              </Spinner>
            </Backdrop> 
          </div>
      </div>
        <Container fluid={true}>
           <Card style={{backgroundColor:"white"}}>
                <CardBody>
                    <Row>
                      <Col>
                        <Breadcrumb title="Report" breadcrumbItem="Booking & Shipment" />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col sm={12} lg={3} md={6} className='mb-auto mt-auto'>
                        <div class="wrapper">
                          <div class="option">
                            <input 
                              class="input" 
                              type="radio" 
                              name="btn1" 
                              id='types'
                              defaultChecked
                              value="monthly" 
                              onChange={(e) => {
                                console.log(e.target.value)
                                setdatatype(e.target.value)
                                settabledata([])
                              }}
                            />
                            <div class="btn1">
                              <span class="span">Monthly</span>
                            </div>
                          </div>
                          <div class="option">
                            <input 
                              class="input" 
                              type="radio" 
                              name="btn1" 
                              id='types'
                              value="overall" 
                              onChange={(e) => {
                                console.log(e.target.value)
                                setdatatype(e.target.value)
                                settabledata([])
                              }}
                            />
                            <div class="btn1">
                              <span class="span">OverAll</span>
                            </div>  
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                        <Col sm={12} lg={3} md={12}>
                            <FormGroup> 
                                <Label for='excompany'>
                                    Company
                                </Label>         
                                {/* <select className="form-control" id='excompany' name='company' type='select'  >
                                    <option>--Select--</option>
                                    {/* <option>{helpdata}</option>
                                </select> */}
                                <Select 
                                     value={Companyvalue}
                                    onChange={(value) => {
                                        console.log(value.value)
                                        setCompanyvalue(value)
                                        // Getbuyervaleu(value.value)
                                        // localStorage.setItem('company',JSON.stringify(value))
                                    }}
                                    options={companyhelp}
                                    styles={{
                                        menuPortal: (provided, state) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        menu: (provided, state) => ({
                                          ...provided,
                                          height: 'auto',
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                      // isDisabled={true}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={12}>
                            <FormGroup> 
                                <Label for='exbuyer'>
                                    Buyer
                                </Label>         
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    value={buyervalue}
                                    name="Buyer"
                                    onChange={(value)=>{
                                        setbuyervalue(value)
                                    }}
                                    options={buyerhelp}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={12}>
                            <FormGroup> 
                                <Label for='exbuyer'>
                                    Year
                                </Label>         
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    value={yearvalue}
                                    name="year"
                                    onChange={(value)=>{
                                        setyearvalue(value)
                                        setperiodtypevalue({ label: "Select", value: "" })
                                        setperiodvalue({ label: "Select", value: "" })
                                    }}
                                    options={yearhelp}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={12}>
                            <FormGroup> 
                                <Label for='exbuyer'>
                                    Period
                                </Label>         
                                <Select
                                    menuPortalTarget={document.body} 
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    value={periodvalue}
                                    name="Buyer"
                                    onChange={(value)=>{
                                        setperiodvalue(value)
                                        periodchange(value.value)
                                    }}
                                    options={periodhelp}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                      <Col sm={12} lg={3} md={12}>
                        <FormGroup> 
                            <Label for='exbuyer'>
                                Period Type
                            </Label>         
                            <Select
                                menuPortalTarget={document.body} 
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                value={periodtypevalue}
                                name="Buyer"
                                isDisabled={periodtypedis}
                                onChange={(value)=>{
                                    setperiodtypevalue(value)
                                    periodtypechange(value.value)
                                }}
                                options={periodtypeoption}
                            />
                        </FormGroup>
                        </Col>
                        <Col sm='12' md='12' lg='3'>
                          <FormGroup> 
                              <Label for='exfromdate'>
                                  From Date
                              </Label>         
                              <Input id='exfromdate' name='Date' type='date' 
                                  value={fromdate}
                                  disabled={fromdatedis}
                                  onChange={(e)=> setfromdate(e.target.value)}
                                  min="1900-01-01" maxLength='4' max="9999-12-31"
                              />
                          </FormGroup>
                        </Col>
                        <Col sm='12' md='12' lg='3'>
                          <FormGroup> 
                              <Label for='extodate'>
                                  To Date
                              </Label>         
                              <Input id='extodate'
                                  onChange={(e)=> settodate(e.target.value)}
                                  min="1900-01-01" maxLength='4' max="9999-12-31"
                                  value={todate}
                                  disabled={todatedis}
                                  name='ToDate' type='date' />
                          </FormGroup>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="d-flex justify-content-end mt-auto mb-auto">
                          <Button size='md' className="mx-1 w-lg" style={{backgroundColor:'#0E21A0',color:'white',fontWeight:'bolder'}} onClick={()=>{viewdata()}}>View</Button>
                          {/* <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47',fontWeight:'bolder'}}    className="btn btn-sm btn-primary w-lg"  onClick={()=>{console.log('first')}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button> */}
                        </Col>
                    </Row>
                    {showTable && (
                    <div className='table-responsive mt-4 tableFixHead'>
                      <Table className=' table table-bordered border-0 table-striped table-sm table'>
                        <thead>
                          <tr>
                              <th className='text-center' rowSpan={2} style={{paddingBottom:'25px',width:'13rem',backgroundColor:'#11244C',color:'white'}}>Buyer</th>
                              <th rowSpan={2} className='text-center' style={{backgroundColor:'#11244C',color:'white'}}>Type</th>
                              {monthss.map((data,index)=>(
                                  <th key={index} className='text-center' colSpan={2} style={{backgroundColor:'#11244C',color:'white'}}>{data}</th>
                              ))}
                          </tr>
                          <tr>
                          {monthss.map((data,index)=>(
                              <>
                                <th className='text-center' style={{backgroundColor:'#11244C',color:'white',position:'sticky',top:'30px'}}>Qty</th>
                                <th className='text-center' style={{backgroundColor:'#11244C',color:'white',position:'sticky',top:'30px'}}>Value</th>
                              </>
                              ))}
                          </tr>
                      </thead>
                     
                        <tbody>
                            {tabledata.map((data,index) => (
                                <React.Fragment>
                                  <tr key={index} className='border-dark'>
                                    <td rowSpan={2}>{data.BUYER}</td>
                                    <td style={{color:'black',fontWeight:'bolder'}} className='text-center'>Ordered</td>
                                    {ordermonthycol.indexOf("JanOD") > -1 &&<td className='text-end'>{numeral(data.JanOD).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("JanODR") > -1 &&<td className='text-end'>{numeral(data.JanODR).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("FebOD") > -1 &&<td className='text-end'>{numeral(data.FebOD).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("FebODR") > -1 &&<td className='text-end'>{numeral(data.FebODR).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("MarOD") > -1 &&<td className='text-end'>{numeral(data.MarOD).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("MarODR") > -1 &&<td className='text-end'>{numeral(data.MarODR).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("AprOD") > -1 &&<td className='text-end'>{numeral(data.AprOD).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("AprODR") > -1 &&<td className='text-end'>{numeral(data.AprODR).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("MayOD") > -1 &&<td className='text-end'>{numeral(data.MayOD).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("MayODR") > -1 &&<td className='text-end'>{numeral(data.MayODR).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("JunOD") > -1 &&<td className='text-end'>{numeral(data.JunOD).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("JunODR") > -1 &&<td className='text-end'>{numeral(data.JunODR).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("JulOD") > -1 &&<td className='text-end'>{numeral(data.JulOD).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("JulODR") > -1 &&<td className='text-end'>{numeral(data.JulODR).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("AugOD") > -1 &&<td className='text-end'>{numeral(data.AugOD).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("AugODR") > -1 &&<td className='text-end'>{numeral(data.AugODR).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("SepOD") > -1 &&<td className='text-end'>{numeral(data.SepOD).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("SepODR") > -1 &&<td className='text-end'>{numeral(data.SepODR).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("OctOD") > -1 &&<td className='text-end'>{numeral(data.OctOD).format('0,0.00')}</td>  }
                                    {ordermonthycol.indexOf("OctODR") > -1 &&<td className='text-end'>{numeral(data.OctODR).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("NovOD") > -1 &&<td className='text-end'>{numeral(data.NovOD).format('0,0.00')}</td> }
                                    {ordermonthycol.indexOf("NovODR") > -1 &&<td className='text-end'>{numeral(data.NovODR).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("DecOD") > -1 &&<td className='text-end'>{numeral(data.DecOD).format('0,0.00')}</td>}
                                    {ordermonthycol.indexOf("DecODR") > -1 &&<td className='text-end'>{numeral(data.DecODR).format('0,0.00')}</td>}
                                  </tr>
                                  <tr className='border-dark'>
                                    <td style={{color:'black',fontWeight:'bolder'}} className='text-center'>Shipped</td>
                                    {shipmonthycol.indexOf("JanSD") > -1 &&<td className='text-end'>{numeral(data.JanSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("JanSDR") > -1 &&<td className='text-end'>{numeral(data.JanSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("FebSD") > -1 &&<td className='text-end'>{numeral(data.FebSD).format('0,0.00')}</td> }
                                    {shipmonthycol.indexOf("FebSDR") > -1 &&<td className='text-end'>{numeral(data.FebSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("MarSD") > -1 &&<td className='text-end'>{numeral(data.MarSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("MarSDR") > -1 &&<td className='text-end'>{numeral(data.MarSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("AprSD") > -1 &&<td className='text-end'>{numeral(data.AprSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("AprSDR") > -1 &&<td className='text-end'>{numeral(data.AprSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("MaySD") > -1 &&<td className='text-end'>{numeral(data.MaySD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("MaySDR") > -1 &&<td className='text-end'>{numeral(data.MaySDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("JunSD") > -1 &&<td className='text-end'>{numeral(data.JunSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("JunSDR") > -1 &&<td className='text-end'>{numeral(data.JunSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("JulSD") > -1 &&<td className='text-end'>{numeral(data.JulSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("JulSDR") > -1 &&<td className='text-end'>{numeral(data.JulSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("AugSD") > -1 &&<td className='text-end'>{numeral(data.AugSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("AugSDR") > -1 &&<td className='text-end'>{numeral(data.AugSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("SepSD") > -1 &&<td className='text-end'>{numeral(data.SepSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("SepSDR") > -1 &&<td className='text-end'>{numeral(data.SepSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("OctSD") > -1 &&<td className='text-end'>{numeral(data.OctSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("OctSDR") > -1 &&<td className='text-end'>{numeral(data.OctSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("NovSD") > -1 &&<td className='text-end'>{numeral(data.NovSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("NovSDR") > -1 &&<td className='text-end'>{numeral(data.NovSDR).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("DecSD") > -1 &&<td className='text-end'>{numeral(data.DecSD).format('0,0.00')}</td>}
                                    {shipmonthycol.indexOf("DecSDR") > -1 &&<td className='text-end'>{numeral(data.DecSDR).format('0,0.00')}</td>}
                                  </tr>
                                </React.Fragment>
                              ))
                            }
                            <tr className='border-dark' style={{backgroundColor:'#99D8D0'}}>
                              <td rowSpan={2} className='text-dark text-center' style={{backgroundColor:'white'}}>TOTAL</td>
                              <td style={{color:'black',fontWeight:'bolder'}} className='text-center'>Ordered</td>
                              {ordermonthycol.indexOf("JanOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JanOD)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("JanODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JanODR)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("FebOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.FebOD)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("FebODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.FebODR)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("MarOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.MarOD)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("MarODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.MarODR)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("AprOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.AprOD)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("AprODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.AprODR)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("MayOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.MayOD)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("MayODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.MayODR)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("JunOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JunOD)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("JunODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JunODR)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("JulOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JulOD)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("JulODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JulODR)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("AugOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.AugOD)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("AugODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.AugODR)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("SepOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.SepOD)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("SepODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.SepODR)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("OctOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.OctOD)  }, 0)).format('0,0.00')}</td>  }
                              {ordermonthycol.indexOf("OctODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.OctODR)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("NovOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.NovOD)  }, 0)).format('0,0.00')}</td> }
                              {ordermonthycol.indexOf("NovODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.NovODR)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("DecOD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.DecOD)  }, 0)).format('0,0.00')}</td>}
                              {ordermonthycol.indexOf("DecODR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.DecODR)  }, 0)).format('0,0.00')}</td>}
                            </tr>
                            <tr className='border-dark' style={{backgroundColor:'#F6FA70'}}>
                              <td style={{color:'black',fontWeight:'bolder'}} className='text-center'>Shipped</td>
                              {shipmonthycol.indexOf("JanSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JanSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("JanSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JanSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("FebSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.FebSD)  }, 0)).format('0,0.00')}</td> }
                              {shipmonthycol.indexOf("FebSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.FebSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("MarSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.MarSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("MarSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.MarSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("AprSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.AprSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("AprSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.AprSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("MaySD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.MaySD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("MaySDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.MaySDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("JunSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JunSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("JunSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JunSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("JulSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JulSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("JulSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.JulSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("AugSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.AugSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("AugSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.AugSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("SepSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.SepSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("SepSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.SepSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("OctSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.OctSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("OctSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.OctSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("NovSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.NovSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("NovSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.NovSDR)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("DecSD") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.DecSD)  }, 0)).format('0,0.00')}</td>}
                              {shipmonthycol.indexOf("DecSDR") > -1 &&<td className='text-end'>{numeral(tabledata.reduce((accumulator, object,) => {return accumulator +(object.DecSDR)  }, 0)).format('0,0.00')}</td>}
                            </tr>
                        </tbody>
                      </Table>
                    </div>
                    )}
                </CardBody>
           </Card>
        </Container>
      </div>

      { notfoundpopup ? (
        <SweetAlert
          title="No Data Found..."
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent:'center',
            alignItems:'center'
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnotfoundpopup(false);
            setShowTable(false)
          }}
        >
        </SweetAlert>
      ):null}

    { perioderr ? (
        <SweetAlert
          title="Select Period"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent:'center',
            alignItems:'center'
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setperioderr(false);
          }}
        >
        </SweetAlert>
      ):null}

      { periodtypeerr ? (
        <SweetAlert
          title="Select Period Type"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent:'center',
            alignItems:'center'
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setperiodtypeerr(false);
          }}
        >
        </SweetAlert>
      ):null}
                  
    </React.Fragment>
  )
}

export default BookingAndShipment;



